import styled from 'styled-components';
import { Text } from 'styles/elements/text';

export const Error = styled(Text)`
    margin-top: 0;
    margin-bottom: 10px;
    font-family: ${props => props.theme.fontFamilyLight};
    font-size: ${props => props.theme.errorMessageFontSize};
    line-height:${props => props.theme.errorMessageLineHeight};
    padding: ${props => props.theme.errorMessagePadding};
    border-radius: ${props => props.theme.errorMessageBorderRadius};
    font-weight: normal;
    background-color: ${props => props.theme.invalidColor};
    color: white;
`;
